import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal, Overline } from "./Reveal";

const StepCounter = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, 7000, {
      duration: 2.4,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setValue(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView]);
  return <span ref={ref} data-testid="constat-steps-counter">{new Intl.NumberFormat("fr-FR").format(value)}</span>;
};

export const Constat = () => (
  <section data-testid="constat-section" className="py-28 sm:py-40 border-b border-black/[0.06]">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <div className="lg:col-span-5">
        <Reveal><Overline>01 — Le constat</Overline></Reveal>
        <Reveal delay={0.1}>
          <p className="font-display font-light tracking-tight leading-none text-[30vw] sm:text-[10rem] lg:text-[12rem] mt-6">
            <StepCounter />
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="font-mono-alt text-xs uppercase tracking-[0.3em] text-[#736F6E] mt-4 flex items-center gap-3">
            <span className="h-1.5 w-1.5 rounded-full bg-[#A8B89A]" />
            pas par jour, en moyenne
          </p>
        </Reveal>
      </div>
      <div className="lg:col-span-7">
        <Reveal delay={0.15}>
          <h2 className="font-display uppercase tracking-tight leading-[1.05] text-3xl sm:text-5xl">
            Au bureau, en ville, en déplacement — nous marchons déjà.
          </h2>
        </Reveal>
      </div>
    </div>
  </section>
);
